import { Column } from '@odin-labs/components';
import React from 'react';

export type ConnectionTableData = {
  id: string;
  externalEntity: {
    type: string;
    typeDisplayName: string;
    id: string;
    name: string;
  };
};

export type ConnectionColumn = Column<ConnectionTableData>;

export const getConnectionColumns = (): ConnectionColumn[] => [
  {
    id: 'type',
    Header: 'Type',
    accessor: (connection): string => connection.externalEntity.typeDisplayName,
  },
  {
    id: 'connectedTo',
    Header: 'Connected to',
    accessor: (connection): string => connection.externalEntity.name,
    Cell: ({
      value,
      row,
    }: {
      value: string;
      row: { original: ConnectionTableData };
    }): React.ReactElement => (
      <span className="odin-block">
        <span className="odin-block odin-text-sm odin-text-gray-900">
          {value}
        </span>
        <span className="odin-block odin-break-all odin-font-mono odin-text-xs odin-text-gray-500">
          {row.original.externalEntity.id}
        </span>
      </span>
    ),
  },
];
